import React, { useState } from 'react'
import moment from 'moment-timezone'
import TableCell from '@material-ui/core/TableCell'
import classNames from 'classnames'
import { Link, Tooltip } from 'components'
import { CONSTANTS, colors } from 'constants/index'
import { useStyles } from './rowStyles'
import { ReactComponent as MainFolderIcon } from 'static/vault/casesList/folder_row.svg'
import { ReactComponent as SecureIcon } from 'static/vault/secure_folder.svg'
import { ReactComponent as ShareIcon } from 'static/cases/share.svg'
import { formatBytes } from 'utils/vault/vault-helpers'
import SharedClientProjectsModal from '../../connections/SharedClientProjectsModal'
import { useSelector } from 'react-redux'

const SecureVaultTableRow = ({ data, timezone }) => {
  const classes = useStyles()
  const currentUser = useSelector(state => state.auth.currentUser)
  const isClient = currentUser?.role === 'client'
  const [showSharedProjectsModal, setShowSharedProjectsModal] = useState(false)
  const [sharedProjectsModalType, setSharedProjectsModalType] = useState('shared_by_me')

  // Determine if folder is shared
  const isSharedByMe = data.isClientFolder && data.sharedWithCount > 0
  const isSharedWithMe = data.isClientFolder && data.sharedBy && data.sharedByName

  const getShareTooltip = () => {
    if (isSharedByMe) {
      return `${data.sharedWithCount} project${
        data.sharedWithCount !== 1 ? 's' : ''
      } shared with other providers for this client.`
    } else if (isSharedWithMe && data.sharedByName) {
      return `This client's projects shared with you by ${data.sharedByName}`
    }
    return ''
  }

  const handleShareIconClick = e => {
    e.stopPropagation()
    e.preventDefault()
    if (isSharedByMe) {
      setSharedProjectsModalType('shared_by_me')
      setShowSharedProjectsModal(true)
    } else if (isSharedWithMe) {
      setSharedProjectsModalType('shared_with_me')
      setShowSharedProjectsModal(true)
    }
  }

  return (
    <>
      <TableCell classes={{ body: classes.tableCell }}>
        <div className={classes.cell}>
          {data.isPrivateFolder ? (
            <SecureIcon className={classes.mainFolderIcon} />
          ) : (
            <MainFolderIcon className={classes.mainFolderIcon} />
          )}
          <Link className={classNames(classes.link, { [classes.boldLink]: data.isPrivateFolder })}>{data.name}</Link>
          {!isClient && (isSharedByMe || isSharedWithMe) && (
            <Tooltip tooltipClass={classes.tooltip} title={getShareTooltip()} placement="bottom-start">
              <ShareIcon
                className={`${classes.shareButton} ${isSharedWithMe ? classes.shareButtonRotated : ''}`}
                onClick={handleShareIconClick}
              />
            </Tooltip>
          )}
        </div>
      </TableCell>
      <TableCell classes={{ body: classes.tableCell }}>{`${formatBytes(data.size)}`}</TableCell>
      <TableCell classes={{ body: classes.tableCell }}>
        {data.lastUploaded
          ? moment(data.lastUploaded)
              .tz(timezone)
              .format(CONSTANTS.DATE_FORMAT.FORMAT_ONE)
          : '-'}
      </TableCell>
      <SharedClientProjectsModal
        isOpen={showSharedProjectsModal}
        onClose={() => {
          setShowSharedProjectsModal(false)
          setSharedProjectsModalType('shared_by_me')
        }}
        clientUuid={data.uniqueUuid}
        clientName={data.name}
        type={sharedProjectsModalType}
        proUuid={sharedProjectsModalType === 'shared_with_me' ? data.sharedBy : undefined}
      />
    </>
  )
}

export default SecureVaultTableRow
